import {FC, useContext, useEffect} from 'react';
import {useRecoilStateLoadable} from 'recoil';
import {useNavigate, useParams} from 'react-router-dom';

import {Box, Button, Paper} from '@mui/material';
import {ReasonRejectionForm} from './ReasonRejectionForm';
import Fallback from '../../../../ui/fallback/Fallback';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import NotFoundErrorInsideComponent from '../../../../ui/not-found/NotFoundErrorInsideComponent';

import {EventBusContext} from '../../../../providers/EventBus';

import {reasonRejectionDictQueryByCodeFamily} from '../../../../store/reasonRejections/selectors';

const ReasonRejectionCode: FC = () => {
  const {id} = useParams();
  const [{state: reasonRejectionState, contents: reasonRejectionContents}, setTaskLocation] = useRecoilStateLoadable(
    reasonRejectionDictQueryByCodeFamily(id),
  );
  const navigate = useNavigate();
  const {bus} = useContext(EventBusContext);

  const loading = reasonRejectionState === 'loading' || !reasonRejectionContents;

  useEffect(() => {
    reasonRejectionState === 'hasValue' && setTaskLocation(reasonRejectionContents);

    reasonRejectionState === 'hasError' && bus?.emit('error', [reasonRejectionContents]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reasonRejectionState]);

  return loading ? (
    <div>
      <Fallback />
    </div>
  ) : reasonRejectionState === 'hasError' ? (
    <NotFoundErrorInsideComponent to="/dictionaries/reasonRejections" />
  ) : (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '70%', margin: '0 auto', mt: 4, mb: 4, p: '8px 16px 16px 16px'}}>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <Button startIcon={<KeyboardReturnIcon />} onClick={() => navigate('/dictionaries/reasonRejections')}>
            Назад
          </Button>
        </Box>
        <ReasonRejectionForm reasonRejection={reasonRejectionContents} />
      </Paper>
    </Box>
  );
};

export default ReasonRejectionCode;
